export enum AutopilotCommandWeight {
    Unknown = 1,
    Initial = 1,
    Takeoff = 1,
    Land = 1,
    Loiter = 2,
    ReturnToLaunch = 3,
    SetAltitude = 2,
    SetSpeed = 2,
    ChangeYaw = 3,
    SetVerticalSpeed = 2,
    SetWaypoint = 3,
    ForkRoute = 1,
    JoinRoute = 1,
    Terminate = 3,
    LaunchParachute = 3,
    MissionArea = 3,
    MissionScan = 3,
    SetHome = 3,
    SetMode = 3,
    SetArmMode = 3,
    LoadFlightPlan = 3,
    LoadOperation = 3,
    FlightPlanStart = 3,
    ContingencyPlanStart = 3,
    LoadFence = 3,
    ActivateFence = 3,
    SelectRoute = 2,
    SelectTakeOff = 2,
    SelectInitial = 2,
    Acknowledge = 3
}